import { storage } from "lib";
import { useCallback, useEffect, useState } from "react";

import HolidayCalendar from "../pages/HolidayCalendar";
import LeaveType from "../pages/LeaveTypeList";
import Shifts from "../pages/ShiftsList";
import WorkingLocation from "../pages/WorkingLocation";
import WorkFlow from "../pages/WorkFlow";



import {
  ATTENDANCE_PAGE,
  ATTENDANCE_PAGE_LIST,
} from "../schemas/attendanceSchema";
import BesmartConditionPages from "../pages/BesmartConditionpages";
import BestampPages from "../pages/BestampPages";
import { useLocation } from "react-router-dom";

function useAttendance() {
  const location = useLocation();
  const [selectedMenu, setMenu] = useState(ATTENDANCE_PAGE.WORKING);

  useEffect(() => {
    if (location.state?.selectedTab) {
      setMenu(location.state.selectedTab);
    }
  }, [location.state]);

  const getPage = useCallback(() => {
    switch (selectedMenu) {
      case ATTENDANCE_PAGE.WORKING:
        return <WorkingLocation />;
      case ATTENDANCE_PAGE.HOLIDAY:
        return <HolidayCalendar />;
      case ATTENDANCE_PAGE.LEAVE:
        return <LeaveType />;
      case ATTENDANCE_PAGE.SHIFTS:
        return <Shifts />;
      case ATTENDANCE_PAGE.WORKFLOW:
        return <WorkFlow />;
      case ATTENDANCE_PAGE.BEPERFROM:
        return <BesmartConditionPages />;
      case ATTENDANCE_PAGE.CONFIGBESMART:
        return <BestampPages />;
      default:
        return <div />;
    }
  }, [selectedMenu]);

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  // useEffect(() => {
  //   const key = storage.sessionStorage.getItem("config.menu");
  //   if (ATTENDANCE_PAGE_LIST.includes(key)) {
  //     setSelectedMenu(key);
  //   } else {
  //     setSelectedMenu(ATTENDANCE_PAGE.WORKING);
  //   }
  // }, []);

  return {
    getPage,
    handleMenuChange,
    selectedMenu
  };
}

export default useAttendance;
